<template>
  <div>
    <el-dialog title="批量指定ID" :visible.sync="dialogVisible" width="520px"
      :close-on-click-modal="false" append-to-body>
      <div class="batch-form">
        <span class="batch-label">指定ID：</span>
        <div class="customer-setting">
          <div class="customer-actions">
            <el-radio-group v-model="form.user_limit_type" @change="changeLimitType">
              <el-radio v-for="item in options" :key="item.value" :label="item.value">{{ item.label }}</el-radio>
            </el-radio-group>
            <el-button v-if="form.user_limit_type === 1" type="primary" size="small"
              @click="$refs.customerSelector.open(form.user_ids)">选择客户</el-button>
          </div>
          <div v-if="form.user_limit_type === 1 && form.user_ids.length" class="selected-customers">
            <div class="selected-customers-title">已选客户ID</div>
            <div v-for="id in form.user_ids" :key="id" class="selected-customer-id">{{ id }}</div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirm">确认</el-button>
      </span>
    </el-dialog>
    <customerSelector ref="customerSelector" @confirm="setCustomers" />
  </div>
</template>

<script>
import customerSelector from './customerSelector'

export default {
  name: 'BatchCustomerSetting',
  components: { customerSelector },
  props: {
    options: { type: Array, default: () => [] }
  },
  data() {
    return {
      dialogVisible: false,
      form: { user_limit_type: 0, user_ids: [] }
    }
  },
  methods: {
    // 批量指定客户每次从“通用”开始，避免沿用上一次选择。
    open() {
      this.form = { user_limit_type: this.options[0].value, user_ids: [] }
      this.dialogVisible = true
    },
    changeLimitType(value) {
      if (value === 0) this.form.user_ids = []
    },
    setCustomers(userIds) {
      this.form.user_ids = userIds
    },
    confirm() {
      if (this.form.user_limit_type === 1 && !this.form.user_ids.length) {
        this.$message.error('指定ID时请选择客户ID')
        return
      }
      this.$emit('confirm', {
        user_limit_type: this.form.user_limit_type,
        user_ids: this.form.user_ids.slice()
      })
      this.dialogVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.batch-form {
  display: flex;
  align-items: flex-start;
  min-height: 80px;
  padding: 10px 20px;
}

.batch-label {
  width: 90px;
  line-height: 40px;
  text-align: right;
  margin-right: 12px;
  flex: none;
}

.customer-setting {
  display: flex;
  align-items: flex-start;
  gap: 24px;
  padding: 10px 8px;

  /deep/.el-radio {
    margin-right: 16px;
  }
}

.customer-actions {
  display: flex;
  flex: none;
  flex-direction: column;
  align-items: flex-end;
  gap: 14px;
}

.selected-customers {
  width: 110px;
  border: 1px solid #dcdfe6;
  text-align: center;
}

.selected-customers-title,
.selected-customer-id {
  min-height: 22px;
  padding: 2px 6px;
  line-height: 18px;
}

.selected-customers-title {
  background: #f5f7fa;
  border-bottom: 1px solid #dcdfe6;
}

.selected-customer-id + .selected-customer-id {
  border-top: 1px solid #ebeef5;
}
</style>
